import Loadable from 'UIComponents/decorators/Loadable';
const AsyncBannerTableContainer = Loadable({
  loader: () => import(
  // @ts-expect-error not migrated to TS yet
  /* webpackChunkName: "banner-table-container" */
  'email-management-lib/refactor/containers/manage/BannerTableContainer'),
  LoadingComponent: () => null
});
export default AsyncBannerTableContainer;